import { render, staticRenderFns } from "./accountModal.vue?vue&type=template&id=561a83b4&scoped=true"
import script from "./accountModal.vue?vue&type=script&lang=js"
export * from "./accountModal.vue?vue&type=script&lang=js"
import style0 from "./accountModal.vue?vue&type=style&index=0&id=561a83b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561a83b4",
  null
  
)

export default component.exports